import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { isBrowser } from '@migros/msrc-browser';

/* eslint-disable no-restricted-globals */
var PREFIX = 'msrc-analytics-';
var track = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(version, widget) {
    var _context, _context2, env, success, _context3;
    return _regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          if (!(!isBrowser() || !navigator.sendBeacon)) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          env = _startsWithInstanceProperty(_context = window.location.host).call(_context, 'test-') ? 'test-' : _startsWithInstanceProperty(_context2 = window.location.host).call(_context2, 'dev-') ? 'dev-' : '';
          success = navigator.sendBeacon("https://".concat(env, "msrc-version-api.migros.ch/track"), _JSON$stringify({
            version: version,
            widget: widget
          }));
          if (success) {
            window.sessionStorage.setItem(_concatInstanceProperty(_context3 = "".concat(PREFIX)).call(_context3, widget), version);
          }
          _context4.next = 11;
          break;
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          console.error('MSRC Version API call failed', _context4.t0);
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function track(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var trackWidgetVersion = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(version, widget) {
    var _context5, sessionVersion;
    return _regeneratorRuntime.wrap(function _callee2$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (isBrowser()) {
            sessionVersion = window.sessionStorage.getItem(_concatInstanceProperty(_context5 = "".concat(PREFIX)).call(_context5, widget));
            if (version !== sessionVersion) {
              track(version, widget);
            }
          }
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee2);
  }));
  return function trackWidgetVersion(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();